import React from "react";
import { Button, Modal } from "react-bootstrap";
import "./StreakPaymentDueModal.scss";
import images from "../../../../utilities/images/images";

const StreakPaymentDueModal = ({
  checkDues,
  paymentDueModal,
  setShowPaymentDueModal,
  getTransactionLists,
}) => {
  return (
    <Modal
      show={paymentDueModal}
      onHide={() => setShowPaymentDueModal(false)}
      //   centered
      className="payment-due-modal_wrapper"
    >
      <Modal.Header closeButton></Modal.Header>
      <Modal.Body>
        <div className="payment-due-modal">
          <img src={images.pendingDue} alt="pending-icon" />
          <div className="payment-due-title">{checkDues?.header_title}</div>
          <div className="payment-due-descript">
            {checkDues?.header_description}
          </div>
          <div className="payment-due-table">
            <table>
              {checkDues?.table_details?.map((elem) => (
                <tr>
                  <td className="key">{elem.due_text}</td>
                  <td className="value">{elem.due_value}</td>
                </tr>
              ))}
            </table>
          </div>
          <div className="payment-due-buttons">
            <div
              className="cancel-btn"
              onClick={() => setShowPaymentDueModal(false)}
            >
              Cancel
            </div>

            <div className="adjust-btn" onClick={() => getTransactionLists(3)}>
              {checkDues?.action_button_label}
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default StreakPaymentDueModal;
